import Skeleton from 'react-loading-skeleton';

const ProfileDocumentsLoading = () => {
  return (
    <>
      <Skeleton
        width={300}
        height={20}
        style={{ marginBottom: 10 }}
      />
      <Skeleton
        width={300}
        height={20}
        style={{ marginBottom: 10 }}
      />
      <Skeleton
        width={300}
        height={20}
        style={{ marginBottom: 10 }}
      />
      <Skeleton
        width={250}
        height={20}
      />
    </>
  );
};

export default ProfileDocumentsLoading;
